import React from 'react';
import { VisuallyHiddenText } from 'shared/legacy';
import classnames from 'classnames';
import invariant from 'invariant';
import stylesheet from './Tag.scss';

const asTypes = {
  'solid-purple': 'solid-purple',
  'outline-purple': 'outline-purple',
  'solid-neutral': 'solid-neutral',
  'outline-neutral': 'outline-neutral',
};

const Tag = ({
  as,
  size = '',
  children,
  altMoreText = '',
  url,
  isExpanded = false,
  onClick,
}) => {
  invariant(
    asTypes[as],
    'You must specify a valid value for the "as" prop when rendering a Tag'
  );

  if (url && onClick) {
    invariant(
      !onClick && !url,
      'You must specify either an onClick to render Tag as a </button>, or a url to render Tag as an </anchor>'
    );
  }

  if (url || onClick) {
    invariant(
      !!altMoreText,
      'You must specify altMoreText along with either an onClick to render Tag as a </button>, or a url to render Tag as an </anchor>'
    );
  }

  const tagClass = classnames(stylesheet.tag, stylesheet[`tag--${as}`], {
    [stylesheet[`tag--${size}`]]: size,
  });

  if (onClick) {
    return (
      <button className={tagClass} onClick={onClick} aria-expanded={isExpanded}>
        <VisuallyHiddenText text={altMoreText} />
        {children}
      </button>
    );
  } else if (url) {
    return (
      <a className={tagClass} href={url}>
        <VisuallyHiddenText text={altMoreText} />
        {children}
      </a>
    );
  }
  return <span className={tagClass}>{children}</span>;
};

export default Tag;
